import React, { useState, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import { Grow, List, MenuItem, Paper } from '@material-ui/core'
import { ProperClickAwayListener } from '../../../components/ProperClickAwayListener'
import { useDefaultMenuItemStyles } from '../../../hooks/defaultSelectStylesHook'
import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'
import { MyProductsColumnCheckbox } from '../../../components/MyProductsColumnCheckbox'

import column from '../../../assets/column.svg'
import { ozonColumns, wbColumns, ymColumns, msColumns } from '../../shared/lib/columns'
import { Button } from '../../shared/ui/button'
import { AccountModelBase } from '../../../server/mpsklad_core/Models/AccountModelBase'

type ColumnSelectorProps = {
  account: AccountModelBase
}

export const ColumnSelector = observer(
  ({account}: ColumnSelectorProps) => {
    const classes = useDefaultMenuItemStyles()
    const [open, setOpen] = useState(false)

    const handleToggle = useCallback(() => {
      setOpen(prevOpen => !prevOpen)
    }, [])

    const handleClose = useCallback(() => {
      setOpen(false)
    }, [])

    const columnsSwitcher = () => {
      switch (account.integrationType) {
        case IntegrationType.Ozon:
          return ozonColumns

        case IntegrationType.Wildberries:
          return wbColumns

        case IntegrationType.YandexMarket:
          return ymColumns

        case IntegrationType.MoySklad:
          return msColumns

        default: {
          const _exhaustive: never = account.integrationType
          throw new Error(`Unsupported integration type: ${_exhaustive}`)
        }
      }
    }

    return (
      <div style={{position: 'relative'}}>
        <Button icon={column} onClick={handleToggle} width={60}/>

        {open && (
          <ProperClickAwayListener isOpen={open} onClose={handleClose}>
            <Grow in={open} style={{transformOrigin: 'top'}}>
              <Paper className={classes.menu} style={{position: 'absolute', zIndex: 1, maxHeight: 'max-content'}}>
                <List component="nav">
                  {columnsSwitcher().map(col => (
                      <MenuItem key={col.id} className={classes.menuItem} style={{fontSize: '12px !important'}}>
                        {/*TODO: Remove ts-ignore after implementing this functional in prod*/}
                        {/*@ts-ignore*/}
                        <MyProductsColumnCheckbox key={col.id} column={col}/>
                      </MenuItem>
                    )
                  )}
                </List>
              </Paper>
            </Grow>
          </ProperClickAwayListener>
        )}
      </div>
    )
  }
)
